import { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import { useTableContext, useTablePropsContext } from "../context";
import { AdvancedFilters, SimpleFilters } from "./ColumnFilters";
import { ExcelButton } from "./ExcelButton";
import { GlobalFilter } from "./GlobalFilter";
import { PredefinedFilters } from "./PredefinedFilters";
import { SettingsButton, useSettingsContext } from "./settings";

import styles from "./styles.module.scss";

type ControlBarProps<TPredefinedFilter extends unknown = unknown> = {
  setPredefinedFilter: Dispatch<SetStateAction<TPredefinedFilter | undefined>>
};

export function ControlBar<T extends unknown = unknown>({ setPredefinedFilter }: ControlBarProps<T>) {
  const table = useTableContext();
  const { controlBarView, hideExportToExcel } = useTablePropsContext();
  const { advancedFilters } = useSettingsContext();

  //todo no fetching
  const hasRecords = !!table.getRowModel().rows.length;

  if (controlBarView === "none") {
    return null;
  }

  return (
    <div className={classNames(styles.root, styles[controlBarView as keyof typeof styles])}>
      <PredefinedFilters
        className={styles.predefinedFilters}
        setPredefinedFilter={setPredefinedFilter}
      />
      <GlobalFilter rootContainerProps={{ className: styles.globalFilter }} />
      {!advancedFilters && <SimpleFilters />}
      <div className={styles.rightBlock}>
        {advancedFilters && <AdvancedFilters />}
        {(hasRecords && !hideExportToExcel) && <ExcelButton />}
        <SettingsButton />
      </div>
    </div>
  );

}